import { render, staticRenderFns } from "./Suspendidos.vue?vue&type=template&id=6bd526ca"
import script from "./Suspendidos.vue?vue&type=script&lang=js"
export * from "./Suspendidos.vue?vue&type=script&lang=js"
import style0 from "./Suspendidos.vue?vue&type=style&index=0&id=6bd526ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports